<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
            </v-toolbar>
        </v-card>
        <v-card color="#1565c0" tile flat>
            <v-list flat color="#004889" class="py-0 d-flex flex-wrap">
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">Select a Size</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-select
                            v-model="form_leads.size"
                            :items="sizes"
                            item-text="title"
                            item-value="id"
                            data-vv-name="size"
                            solo
                            flat
                            dark
                            hide-details
                            clearable
                        ></v-select>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">Status</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-select
                            v-model="form_leads.status"
                            :items="leadStatuses"
                            item-text="label"
                            item-value="value"
                            required
                            :error-messages="errors"
                            solo
                            flat
                            dark
                        ></v-select>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">Select a Shape</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-select
                            v-model="form_leads.shape"
                            :items="shapes"
                            item-text="title"
                            item-value="id"
                            data-vv-name="shape"
                            solo
                            flat
                            dark
                            hide-details
                            clearable
                        ></v-select>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">Pool Addons</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-select
                            v-model="form_leads.option"
                            :items="options"
                            item-text="title"
                            item-value="id"
                            small-chips
                            solo
                            flat
                            dark
                            hide-details
                            clearable
                        >
                        </v-select>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">City</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                            <v-text-field
                                v-model="form_leads.city"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                            ></v-text-field>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">County</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                            <v-autocomplete
                                :items="counties"
                                :filter="customFilter"
                                :error-messages="errors"
                                v-model="form_leads.county"
                                color="white"
                                item-text="title"
                                item-value="id"
                                label="County"
                                required
                                solo
                                flat
                                dark
                                clearable
                            ></v-autocomplete>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">From Date</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-menu
                            v-model="menustartlead"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="computedLeadStartDateFormatted"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                solo
                                flat
                                dark
                                clearable
                            ></v-text-field>
                            </template>
                            <v-date-picker
                            v-model="form_leads.start_date"
                            @input="menustartlead = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">End Date</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-menu
                            v-model="menuendlead"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="computedLeadEndDateFormatted"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                solo
                                flat
                                dark
                                clearable
                            ></v-text-field>
                            </template>
                            <v-date-picker
                            v-model="form_leads.end_date"
                            @input="menuendlead = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">Supervisor</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-select
                            v-model="form_leads.supervisor"
                            :items="users"
                            item-text="name"
                            item-value="id"
                            label="Supervisor"
                            clearable
                            solo
                            flat
                            dark
                            hide-details
                        ></v-select>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">Group By</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-select
                            v-model="form_leads.group_by"
                            :items="group_by"
                            item-text="label"
                            item-value="value"
                            solo
                            flat
                            dark
                            hide-details
                            clearable
                        >
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row third">
                    <v-list-item-content class="label">
                        <v-list-item-title class="white--text font-weight-bold">Date Field</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-select
                            v-model="form_leads.date_type"
                            :items="date_type"
                            item-text="label"
                            item-value="value"
                            solo
                            flat
                            dark
                            hide-details
                            clearable
                        >
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="form-row thrid">
                    <v-list-item-content class="label">
                    
                    </v-list-item-content>
                    <v-list-item-action class="justify-end">
                        <v-btn
                            color="#ffffff"
                            class="primary--text"
                            tile
                            large
                            @click="getResultsLeads"
                            :loading="loading"
                            >
                                Generate
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item class="pa-0 w-100">
                    <v-list-item-content class="pa-0">
                        <v-card v-if="results_leads.total" color="#003a6f" flat tile>
                            <v-card-text class="d-flex flex-wrap align-center">
                                <v-chip-group
                                    active-class="deep-purple accent-4 white--text"
                                    column
                                >
                                    <v-chip
                                    >
                                        Total Submissions: {{ results_leads.total }}
                                    </v-chip>
                                </v-chip-group>
                                <v-spacer></v-spacer>
                                <downloadexcel
                                    class            = "btn"
                                    :fetch           = "fetchData"
                                    :fields          = "json_fields"
                                    :before-generate = "startDownload"
                                    :before-finish   = "finishDownload"
                                    name="export.xls"
                                    v-if="results_leads.total > 0"
                                    >
                                    <v-btn
                                        color="#ffffff"
                                        class="primary--text"
                                        tile
                                        small
                                        :loading="downloadLoading"
                                        >
                                            Export
                                    </v-btn>
                                </downloadexcel>

                                <downloadexcel
                                    class            = "btn ml-2"
                                    :fetch           = "fetchDataSummary"
                                    :fields          = "json_fields2"
                                    :before-generate = "startDownload2"
                                    :before-finish   = "finishDownload2"
                                    name="export.xls"
                                    v-if="results_leads.total > 0 && form_leads.group_by"
                                    >
                                    <v-btn
                                        color="#ffffff"
                                        class="primary--text"
                                        tile
                                        small
                                        :loading="downloadLoading2"
                                        >
                                            Export Summary
                                    </v-btn>
                                </downloadexcel>
                            </v-card-text>
                        </v-card>
                        <v-data-table
                            :headers="headers_groups"
                            :items="results_leads.stats"
                            :items-per-page="100"
                            class="elevation-1"
                            mobile-breakpoint="0"
                            v-if="results_leads.stats.length"
                        >
                            <template v-slot:item.percentage="props">
                                {{ props.item.percentage + '%' }}
                            </template>                                   
                        </v-data-table>
                        <v-data-table
                            :headers="headers_leads"
                            :items="results_leads.data"
                            :items-per-page="100"
                            class="elevation-1"
                            mobile-breakpoint="0"
                            v-else
                        >
                            <template v-slot:item.customer="props">
                                <router-link
                                    :to="`/lead/${props.item.id}`"  target="_blank"
                                >
                                    <NavLink>{{ props.item.first_name + ' ' + props.item.last_name }}</NavLink>
                                </router-link>
                            </template>
                            <template v-slot:item.county="props">
                                {{ getCountyName(props.item.county) }}
                            </template>
                            <template v-slot:item.created_at="props">
                                {{ formatDate(props.item.created_at) }}
                            </template>
                            <template v-slot:item.updated_at="props">
                                {{ formatDate(props.item.updated_at) }}
                            </template>
                            <template v-slot:item.under_contract_at="props">
                                {{ formatDate(props.item.under_contract_at) }}
                            </template>
                            <template v-slot:item.quote="props">
                                {{ props.item.quote | currency }}
                            </template>
                            <template v-slot:item.status="props">
                                <v-chip
                                class="mr-2 mb-1"
                                :color="getColor(props.item.status)"
                                text-color="white"
                                small
                                label
                                v-if="props.item.status == 'confirmed'"
                                >
                                Approved
                                </v-chip>
                                <v-chip
                                class="mr-2 mb-1"
                                :color="getColor(props.item.status)"
                                text-color="white"
                                small
                                label
                                v-else
                                >
                                {{ props.item.status | capitalize }}
                                </v-chip>
                            </template>                                     
                        </v-data-table>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import mixin from '../../mixin/main.js'
    import axios from 'axios'
    import downloadexcel from "vue-json-excel"

    export default {
        mixins: [mixin],
        data () {
            return {
                date: new Date().toISOString().substr(0, 10),
                menustartpool: false,
                menuendpool: false,
                menustartlead: false,
                menuendlead: false,
                form_leads: {
                    size: '',
                    shape: '',
                    start_date: '',
                    end_date: '',
                    status: 'all',
                    option: '',
                    city: '',
                    county: '',
                    group_by: '',
                    date_type: 'created_at',
                    supervisor: '',
                },
                results_leads: {
                    data: [],
                    total: '',
                    sum: '',
                    stats: []
                },
                loading: false,
                headers_leads: [
                    { text: 'Customer', align: 'start', sortable: false, value: 'customer' },
                    { text: 'City', value: 'city' },
                    { text: 'County', value: 'county' },
                    { text: 'Status', value: 'status' },
                    { text: 'Medium', value: 'medium' },
                    { text: 'Source', value: 'source' },
                    { text: 'Host', value: 'host' },
                    { text: 'Refferer', value: 'how_did_your_hear' },
                    { text: 'Created at', value: 'created_at', sortable: false },
                    { text: 'Updated at', value: 'updated_at', sortable: false },
                    { text: 'Under Contract at', value: 'under_contract_at', sortable: false },
                ],
                headers_groups: [
                    { text: 'Source', align: 'start', sortable: false, value: 'label' },
                    { text: 'No. of entries', value: 'value' },
                    { text: 'Percentage', value: 'percentage' },
                ],
                yes_no: [
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                ],
                group_by: [
                    { label: 'Source', value: 'how_did_your_hear' },
                    { label: 'County', value: 'county' },
                    { label: 'Zone', value: 'zone' },
                    { label: 'Size', value: 'size' },
                    { label: 'Shape', value: 'shape' },
                ],
                date_type: [
                    { label: 'Created at', value: 'created_at' },
                    { label: 'Updated at', value: 'modified_at' },
                    { label: 'Under Contract at', value: 'under_contract_at' },
                    { label: 'In Progress at', value: 'in_progress_at' },
                ],
                downloadLoading: false,
                json_fields: {
                    'Submission Date': 'created_at',
                    'Customer Name': 'customer_name',
                    'Address': 'address',
                    'City': 'city',
                    'Zip Code': 'zip',
                    'County': 'county',
                    'Phone': 'phone',
                    'Work Phone': 'workphone',
                    'Email': 'email',
                    'Status': 'status',
                    'Source': 'how_did_your_hear',
                    'Service': 'service',
                    'Preffered Contact Method': 'preffered_contact',
                    'Preffered Time': 'preffered_time',
                    'Pool Size': 'pool_size',
                    'Pool Shape': 'pool_shape',
                    'Referer Medium': 'medium',
                    'Referer Source': 'source',
                    'Referer Host': 'host',                    
                },
                downloadLoading2: false,
                json_fields2: {
                    'Source': 'label',
                    'No. Of Entries': 'value',
                    'Percentage': 'percentage',
                },
            }
        },
        components: {
            downloadexcel,
        },
        created() {
            this.pageTitle = this.$route.meta.title
        },
        computed: {
            ...mapGetters({
                sizes: 'data/sizes',
                shapes: 'data/shapes',
                options: 'data/options',
                statuses: 'data/jobStatusArray',
                liner_color: 'data/liner_color',
                counties: 'data/counties',
                leadStatuses: 'data/statusArray',
                users: 'data/users',
            }),
            computedLeadStartDateFormatted () {
                return this.formatDate(this.form_leads.start_date)
            },
            computedLeadEndDateFormatted () {
                return this.formatDate(this.form_leads.end_date)
            },
        },
        methods: {
            getResultsLeads() {
                this.loading = true
                axios.post('crm/report/leads', this.form_leads)
                    .then((response) => {
                        this.loading = false
                        this.results_leads = response.data
                        this.$nextTick()
                    })
            },
            customFilter (item, queryText) {
                const textOne = item.title.toLowerCase()
                const searchText = queryText.toLowerCase()

                return textOne.indexOf(searchText) > -1
            },
            getCountyName(county) {
                let cty = this.counties.filter(c => {
                    return c.id == county
                })

                if(cty.length) {
                    return cty[0].title
                }
            },
            getColor(status) {
                switch(status) {
                    case 'considering':
                        return 'light-blue'
                    case 'confirmed':
                        return 'green'
                    case 'sold':
                        return 'purple'
                    case 'revisit':
                        return 'orange'
                    case 'lost':
                        return 'red'
                    case 'still_out_of_budget':
                        return '#9f9f9f'
                    case 'cost_is_higher':
                        return '#9f9f9f'
                    default:
                        // code block
                }
            },
            async fetchData(){
                const response = await axios.get('crm/leads/export_report', {
                    params: this.form_leads
                });
                return response.data;
            },
            async fetchDataSummary(){
                const response = await axios.get('crm/leads/export_summary', {
                    params: this.form_leads
                });
                return response.data;
            },
            startDownload(){
                this.downloadLoading = true
            },
            finishDownload(){
                this.downloadLoading = false
            },
            startDownload2(){
                this.downloadLoading2 = true
            },
            finishDownload2(){
                this.downloadLoading2 = false
            }
        }
    }
</script>

<style lang="sass">
.w-100
    width: 100%

@media only screen and (min-width: 600px)
    .form-row
        &.half 
            max-width: 50%

        &.third
            max-width: 33.33%
</style>